<div>
    <powerbi-report [embedConfig]="insightModel" [cssClassName]="reportClass"></powerbi-report>
</div>